// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl: 'https://allout.ae/vendor-panel/api/v1',
  apiBaseUrl: 'https://staging-api.allout.ae/vendor-panel/api/v1',
  // apiBaseUrl: 'http://192.168.100.13:3152/vendor-panel/api/v1',

  firebase: {
    apiKey: "AIzaSyDAAE27Q7HNFYKfjfuN_e3MO2lzwzwlBwc",
    authDomain: "all-out-1337f.firebaseapp.com",
    projectId: "all-out-1337f",
    storageBucket: "all-out-1337f.appspot.com",
    messagingSenderId: "168378252615",
    appId: "1:168378252615:web:b52199827be9192d872062",
    vapidKey: "BEr_kZjs7_kuMTRT5uk-6dNGb3oe1MOg1t3ej8BBQVrrX1abIvLk5OxsdFJdxE0yp8qKHUfFq_HIes5WUH1C4_k",
  },
  googleMapApiKey: 'AIzaSyB50-kXuOn3zBMljPoGNljD97gjSzV0XaI',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
